import React from 'react'
import { colors } from '../../Colors'

export interface IProps {
    width?: number
    height?: number
    color?: string
}

const StarIcon = ({ width = 24, height = 24, color = colors.grey[50] }: IProps) => {
    return (
        <svg xmlns='http://www.w3.org/2000/svg' width={width} height={height} viewBox='0 0 24 24' fill='none'>
            <path
                d='M12.6128 1.94722L14.9128 8.75682L22.0992 8.84002C22.7176 8.84722 22.9736 9.63522 22.4776 10.004L16.712 14.2952L18.8536 21.156C19.0376 21.7464 18.368 22.2328 17.8632 21.8752L12.0008 17.7176L6.13763 21.8744C5.63363 22.232 4.96323 21.7448 5.14723 21.1552L7.28883 14.2944L1.52323 10.0032C1.02723 9.63442 1.28323 8.84642 1.90163 8.83922L9.08803 8.75602L11.388 1.94642C11.5864 1.36082 12.4152 1.36082 12.6128 1.94722Z'
                fill={color}
            />
        </svg>
    )
}

export default React.memo(StarIcon)
